module.exports = __webpack_public_path__ + "img/H20-1.png";